
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
import { IWykrojnikRow } from "./IWykrojnikRow";
import { wykrojnik_api } from "./IWykrojnikSvc";
const bus: Bus = new Bus().getBus();


@Component({  components: { } })
export default class WykrojnikRowVue extends Vue {
  @Prop(Object) w:any;
  
  sel='sel'
  nsel='nsel'
  key:number=0;

  created() {
    bus.register("hilight_wykrojnik",this.hilight)
  }

  selected_clicked(w:any) {
    bus.fire("wykrojnik_selected_clicked", w)
    console.log(w)
  }

  async hilight(e:any) {
    this.key++;
  }

  is_selected(w:IWykrojnikRow|undefined) {
    return wykrojnik_api.eq(w,wykrojnik_api.selected)
  }
}

